import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { APP_CONFIG } from '../config/app';
import MainLayout from '../layouts/MainLayout';
import HomePage from '../pages/HomePage';
import DepannageInformatique from '../pages/DepannageInformatique';
import CreationSiteWeb from '../pages/CreationSiteWeb';
import UserDashboard from '../pages/UserDashboard';
import TicketDetail from '../pages/TicketDetail';
import ExpertsMap from '../pages/ExpertsMap';
import PrivateRoute from './PrivateRoute';
import PolitiqueConfidentialite from '../pages/legal/PolitiqueConfidentialite';
import MentionsLegales from '../pages/legal/MentionsLegales';
import ConditionsUtilisation from '../pages/legal/ConditionsUtilisation';
import VerifyEmail from '../pages/VerifyEmail';
import BlogIndex from '../pages/blog/BlogIndex';
import BlogSilo from '../pages/blog/BlogSilo';
import BlogArticle from '../pages/blog/BlogArticle';
import DepannageGenevois from '../pages/local/DepannageGenevois';
import DepannageSaintJulien from '../pages/local/DepannageSaintJulien';
import DepannageAnnemasse from '../pages/local/DepannageAnnemasse';
import DepannageAnnecy from '../pages/local/DepannageAnnecy';
import DepannageGex from '../pages/local/DepannageGex';
import DepannageViry from '../pages/local/DepannageViry';
import DepannageValleiry from '../pages/local/DepannageValleiry';
import DepannageSaintGenis from '../pages/local/DepannageSaintGenis';
import DepannageFerney from '../pages/local/DepannageFerney';
import DepannageDivonne from '../pages/local/DepannageDivonne';
import DepannagePrevessin from '../pages/local/DepannagePrevessin';
import DepannageArchamps from '../pages/local/DepannageArchamps';
import DepannageCollonges from '../pages/local/DepannageCollonges';
import DepannageOrnex from '../pages/local/DepannageOrnex';
import DepannageCessy from '../pages/local/DepannageCessy';
import DepannageSegny from '../pages/local/DepannageSegny';
import DepannageGeneve from '../pages/local/DepannageGeneve';
import ContactPage from '../pages/ContactPage';

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout><Outlet /></MainLayout>}>
        <Route path={APP_CONFIG.routes.home} element={<HomePage />} />
        <Route path={APP_CONFIG.routes.depannage} element={<DepannageInformatique />} />
        <Route path={APP_CONFIG.routes.creationSite} element={<CreationSiteWeb />} />
        <Route path={APP_CONFIG.routes.expertsMap} element={<ExpertsMap />} />
        
        {/* Routes protégées */}
        <Route
          path={APP_CONFIG.routes.monEspace}
          element={
            <PrivateRoute>
              <UserDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={APP_CONFIG.routes.tickets}
          element={
            <PrivateRoute>
              <TicketDetail />
            </PrivateRoute>
          }
        />

        {/* Pages légales */}
        <Route path={APP_CONFIG.routes.politiqueConfidentialite} element={<PolitiqueConfidentialite />} />
        <Route path={APP_CONFIG.routes.mentionsLegales} element={<MentionsLegales />} />
        <Route path={APP_CONFIG.routes.conditionsUtilisation} element={<ConditionsUtilisation />} />

        {/* Blog */}
        <Route path={APP_CONFIG.routes.blog} element={<BlogIndex />} />
        <Route path={APP_CONFIG.routes.blogSilo} element={<BlogSilo />} />
        <Route path={APP_CONFIG.routes.blogArticle} element={<BlogArticle />} />

        {/* Pages SEO locales */}
        <Route path={APP_CONFIG.routes.depannageGenevois} element={<DepannageGenevois />} />
        <Route path={APP_CONFIG.routes.depannageSaintJulien} element={<DepannageSaintJulien />} />
        <Route path={APP_CONFIG.routes.depannageAnnemasse} element={<DepannageAnnemasse />} />
        <Route path={APP_CONFIG.routes.depannageAnnecy} element={<DepannageAnnecy />} />
        <Route path={APP_CONFIG.routes.depannageGex} element={<DepannageGex />} />
        <Route path={APP_CONFIG.routes.depannageViry} element={<DepannageViry />} />
        <Route path={APP_CONFIG.routes.depannageValleiry} element={<DepannageValleiry />} />
        <Route path={APP_CONFIG.routes.depannageSaintGenis} element={<DepannageSaintGenis />} />
        <Route path={APP_CONFIG.routes.depannageFerney} element={<DepannageFerney />} />
        <Route path={APP_CONFIG.routes.depannageDivonne} element={<DepannageDivonne />} />
        <Route path={APP_CONFIG.routes.depannagePrevessin} element={<DepannagePrevessin />} />
        <Route path={APP_CONFIG.routes.depannageArchamps} element={<DepannageArchamps />} />
        <Route path={APP_CONFIG.routes.depannageCollonges} element={<DepannageCollonges />} />
        <Route path={APP_CONFIG.routes.depannageOrnex} element={<DepannageOrnex />} />
        <Route path={APP_CONFIG.routes.depannageCessy} element={<DepannageCessy />} />
        <Route path={APP_CONFIG.routes.depannageSegny} element={<DepannageSegny />} />
        <Route path={APP_CONFIG.routes.depannageGeneve} element={<DepannageGeneve />} />

        {/* Contact */}
        <Route path={APP_CONFIG.routes.contact} element={<ContactPage />} />

        {/* Vérification d'email */}
        <Route path="/verify-email" element={<VerifyEmail />} />

        {/* Redirection de /dashboard vers /mon-espace */}
        <Route path="/dashboard" element={<Navigate to={APP_CONFIG.routes.monEspace} replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes; 